import React, { useEffect, useState } from "react";
import { api, formatDateTime } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/app/ui-bits";
import { FileText, MagnifyingGlass } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");

  const load = async () => {
    const params = {};
    if (query) params.action = query;
    const { data } = await api.get("/audit-logs", { params });
    setLogs(data);
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const filtered = logs.filter((l) =>
    !query || l.action?.toLowerCase().includes(query.toLowerCase()) ||
    l.user_email?.toLowerCase().includes(query.toLowerCase()) ||
    l.entity?.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div data-testid="audit-page">
      <PageHeader
        eyebrow="Security"
        title="Audit Log"
        description="Logins, password changes, user actions, IP addresses, and task creation/updates."
      />
      <div className="p-8">
        <div className="mb-4 flex items-center gap-2">
          <div className="relative w-full max-w-md">
            <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
            <Input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Filter by action, user email, entity…"
              className="pl-9 rounded-sm"
              data-testid="audit-filter-input"
            />
          </div>
        </div>

        {loading ? (
          <div className="font-mono-alt text-xs uppercase tracking-[0.25em] text-zinc-500">Loading…</div>
        ) : filtered.length === 0 ? (
          <EmptyState icon={FileText} title="No activity" description="Audit events will appear here as users interact with the system." />
        ) : (
          <div className="border border-zinc-200 bg-zinc-950 font-mono-alt text-xs text-emerald-300">
            <div className="border-b border-zinc-800 bg-zinc-900 px-4 py-2 text-[10px] uppercase tracking-widest text-zinc-400">
              DESCON · oms-audit.log · {filtered.length} records
            </div>
            <ul className="max-h-[70vh] overflow-y-auto">
              {filtered.map((l) => (
                <li key={l.id} className="flex flex-wrap gap-3 border-b border-zinc-800 px-4 py-2 text-zinc-200" data-testid={`audit-${l.id}`}>
                  <span className="w-44 shrink-0 text-zinc-500">{formatDateTime(l.created_at)}</span>
                  <span className="w-48 truncate text-white">{l.user_email || "system"}</span>
                  <span className="w-20 text-zinc-400">{l.ip || "—"}</span>
                  <span className="uppercase tracking-wider text-emerald-300">{l.action}</span>
                  {l.entity && <span className="text-zinc-400">[{l.entity}{l.entity_id ? `:${l.entity_id.slice(0, 8)}` : ""}]</span>}
                  {l.details && Object.keys(l.details).length > 0 && (
                    <span className="flex-1 truncate text-zinc-500">{JSON.stringify(l.details)}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
